<template>
  <div class="user-protocal">
    <label for="radio-protocal" class="radio-protocal" @change="select">
      <div class="radio">
        <input class="radio-input" name="radio-input" id="radio-protocal" type="checkbox" :checked="selected ? 'checked' : ''">
        <label class="radio-label" for="radio-protocal">
        </label>
      </div>
    </label>
    <p class="user-protocal-title"><span>{{gettext('同意')}}</span> <span class="link" @click="handleJump('TC')">{{gettext('《法律声明')}}</span><span> {{gettext('与')}} </span><span class="link" @click="handleJump('PP')">{{gettext('隐私政策》')}}</span></p>
  </div>
</template>
<script>
import getCountryConfig from '@/common/config/country-config'
import store from '@/store'
const { country } = store.state
export default {
  name: 'TelValidate',
  props: {
    tcProtocol: {
      type: String,
      default: getCountryConfig.middleLink.TC_PROTOCOL_URL(country)
    },
    ppProtocol: {
      type: String,
      default: getCountryConfig.middleLink.PP_PROTOCOL_URL(country)
    }
  },
  data () {
    return {
      selected: false
    }
  },
  mounted () {
  },
  watch: {
    value: function (val) {
      this.tel.number = val
    }
  },
  methods: {
    handleClick () {
      // 勾中同意用户协议才可提交
      if (this.selected) {
        this.$emit('confirm', this.tel, +this.selected)
      } else {
        const toast = this.$createToast({
          txt: this.gettext('必须同意用户条款，才能继续下一步'),
          time: 3000,
          type: 'warn',
          mask: false
        })
        toast.show()
      }
    },
    selectHandle (selectedVal, selectedIndex, selectedText) {
      this.selectedValue = this.countryList.data.data.data[selectedIndex]
      this.tel.max = this.selectedValue.max_len
      this.tel.min = this.selectedValue.min_len
      this.tel.code = this.selectedValue.calling_code
    },
    select () {
      this.selected = !this.selected
      this.$emit('select', this.selected)
    },
    handleJump (str) {
      // 跳转用户协议链接
      if (str === 'TC') {
        location.href = this.tcProtocol
      } else {
        location.href = this.ppProtocol
      }
    }
  }
}
</script>
<style lang="stylus">
@import "~@/common/stylus/variables"
.user-protocal {
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 64px;
  &-title {
    text-align: left;
    font-size: 28px;
    line-height: 32px;
    font-family: 'Aspira Regular'
    span {
      font-family: 'Aspira Regular'
      &.link {
        font-color()
        cursor: pointer;
      }
    }
  }
  .radio-protocal {
    position: absolute;
    top: 50%;
    margin-top: -20px;
    left: 0;
    // display: flex;
    // align-items: center;
  }
  .radio {
    width: 40px
    height: 40px
    input {
      &.radio-input {
        width: 40px
        height: 40px
        display: none
      }
      &:checked {
        & + label {
          border: 0;
          new-coupon-check-label-bg()
        }
      }
    }
    .radio-label {
      width: 40px
      height: 40px
      box-sizing: border-box
      display: inline-block
      border-radius: 50%
      background: #FFFFFF
      background-size: auto 100%
      border: 2px solid #CCCCCC
    }
  }
}
>>> .rich-toast .rich-popup-content .rich-toast-tip {
  max-height: none;
}
</style>